module.exports = __webpack_public_path__ + "img/get-rewards.33e496b7.png";